module.exports = __webpack_public_path__ + "media/images/lane/icon_star-2a71aa2a6b04f3a91efeca02afd0bc7e.svg";